
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import Swal from 'sweetalert2';
import { Table, Autocomplete, TableBody, Grid, FormControlLabel, Checkbox, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

function AddTipoPartidaContable ({ handleNewTipoPartidaContable, editTipoPartidaContable, cancelarEdicion}){
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [codigo, setCodigo] = useState('');
    const [descripcionTipoPartida, setDescripcionTipoPartida] = useState('');
    const [automatica, setAutomatica] = useState(false);
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

       const { user } = useUser();
       const { tienePermiso } = useAccesos();
            // Obtener la fecha y hora actual
            function obtenerFechaISOsinZ() {
                const fecha = new Date();
                let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
                fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
                return fechaISO;
        }
    
        // Convertir a una cadena en formato ISO 8601
            const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        if (editTipoPartidaContable) {
            setCodigo(editTipoPartidaContable.codigo);
            setDescripcionTipoPartida(editTipoPartidaContable.descripcionTipoPartida); // Cargar la descripción de la raza para editar
            setAutomatica(editTipoPartidaContable.automatica || fase);
            setModificacion(2);
            setIngresadoPor(editTipoPartidaContable.ingresadoPor);
    
        } else {
            setCodigo('');
            setDescripcionTipoPartida(''); // Resetear la descripción si no estamos editando
            setAutomatica(false);
            setModificacion(1);
            setIngresadoPor('');
    
        }
    }, [editTipoPartidaContable]);

    const handleSubmit = async (e) => {
                e.preventDefault();
                const method = editTipoPartidaContable ? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
                const endpoint = editTipoPartidaContable ? `${server}/CtbTipoPartidums/${editTipoPartidaContable.id}` : `${server}/CtbTipoPartidums`;
        
                const tipoPartidaContable = { 
                    id:editTipoPartidaContable ? editTipoPartidaContable.id:0,
                    codigo,
                    descripcionTipoPartida: descripcionTipoPartida,
                    automatica,
                    IngresadoPor: !editTipoPartidaContable ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                    ModificadoPor: editTipoPartidaContable ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                    fechaIngreso: fechaFormateada
                };
                Object.keys(tipoPartidaContable).forEach(key => tipoPartidaContable[key] === undefined && delete tipoPartidaContable[key]);
        
                try {
                    const response = await fetch(endpoint, {
                        method: method,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(tipoPartidaContable),
                    });
        
                    if (response.ok) {
                        // Limpiar el formulario y manejar la respuesta si es necesario
                        setCodigo('');
                        setDescripcionTipoPartida('');
                        setAutomatica(false);
                        Swal.fire({
                            icon: 'success',
                            title: 'Operación exitosa',
                            showConfirmButton: false,
                            timer: 1500
                        });         
                        handleNewTipoPartidaContable();
                    } else {
                        const errorData = await response.json();
                        const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                        Swal.fire({
                            icon: 'error',
                            title: `Error ${response.status}`,
                            text: errorMessage,
                        });            }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al guardar la raza',
                        text: error || 'Ocurrió un error inesperado',
                    });        }
            };
    
        
            const handleCancelarEdicion = () => {
                setCodigo('');
                setDescripcionTipoPartida('');
                setAutomatica(false);
                setModificacion(1);
                setIngresadoPor('');
                if (cancelarEdicion) cancelarEdicion();
            };

    return (
        <>
        {/* <h2>{editEtnia ? 'Editar Etnia' : 'Agregar Nueva Etnia'}</h2> */}
         <h2>{editTipoPartidaContable ? 'Editar Tipo de Partida' : 'Agregar nuevo Tipo de Partida'}</h2>
        <br />
        <form id="formEtnia" className="form-horizontal form-label-left" onSubmit={handleSubmit}>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionTipoPartida">
                    Codigo: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="descripcionEtnia"
                        required="required"
                        className="form-control"
                        value={codigo}
                        onChange={(e) => setCodigo(e.target.value)}
                    />
                </div>                
            </div>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionTipoPartida">
                    Descripción del tipo de partida: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="descripcionEtnia"
                        required="required"
                        className="form-control"
                        value={descripcionTipoPartida}
                        onChange={(e) => setDescripcionTipoPartida(e.target.value)}
                    />
                </div>
                <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="cumplido">
                    Es automatica:
                </label>
                {/* Checkbox en su columna alineado */}
                <div className="col-md-4 col-sm-3 d-flex align-items-center">
                    <Checkbox
                    checked={automatica}
                    onChange={(e) => setAutomatica(e.target.checked)}
                    />
                </div>                
            </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Tipo Partida Contable')}>
                        {editTipoPartidaContable ? 'Actualizar' : 'Guardar'}
                    </button>
                     {editTipoPartidaContable && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                            Cancelar
                        </button>  
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddTipoPartidaContable;